import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CustomerAccountSidebar extends ThemeComponent {
    @Ref({required: false}) trigger!: HTMLButtonElement;

    init() {
        if (!this.trigger) { return; }

        this.$listen(this.trigger, 'click', () => {
            this.trigger.classList.toggle('is-active');
            this.trigger.nextElementSibling?.classList.toggle('is-active');
            document.body.classList.toggle('no-scroll');
        });
    }

}
